import { notification } from "antd";
import { ofType } from "redux-observable";
import { empty, of } from "rxjs";
import { concat } from "rxjs";
import { mergeMap } from "rxjs/operators";
import { push } from "react-router-redux";
import normalize from "json-api-normalizer";

import { errorHandles } from "../ducks/app";
import {
  DELETE_PATIENT_CONDITION_FAILURE_ACTION,
  DELETE_PATIENT_PROGRAM_FAILURE_ACTION,
  LINK_PROGRAMS_FAILURE_ACTION,
  LOAD_PATIENT_FAILURE_ACTION,
  SAVE_PATIENT_CONDITION_FAILURE_ACTION,
  SAVE_PATIENT_FAILURE_ACTION,
  SAVE_PATIENT_PROGRAM_FAILURE_ACTION,
  SAVE_PATIENT_PROGRAM_ITEM_FAILURE_ACTION
} from "../ducks/patient";

import {
  LOAD_CONDITIONS_FAILURE_ACTION,
  DELETE_CONDITION_FAILURE_ACTION,
  DELETE_PROGRAM_FAILURE_ACTION,
  DELETE_PROGRAM_ITEM_FAILURE_ACTION,
  DELETE_TASK_FAILURE_ACTION,
  LOAD_PATIENTS_FAILURE_ACTION,
  LOAD_PROGRAM_FAILURE_ACTION,
  LOAD_PROGRAMS_FAILURE_ACTION,
  LOAD_TASKS_FAILURE_ACTION,
  SAVE_CONDITION_FAILURE_ACTION,
  SAVE_PROGRAM_FAILURE_ACTION,
  SAVE_PROGRAM_ITEM_FAILURE_ACTION,
  SAVE_TASK_FAILURE_ACTION,
  DELETE_ACCOUNT_FAILURE_ACTION,
  DELETE_LOCATION_FAILURE_ACTION,
  DELETE_USER_FAILURE_ACTION,
  SAVE_ACCOUNT_FAILURE_ACTION,
  SAVE_LOCATION_FAILURE_ACTION,
  SAVE_USER_FAILURE_ACTION,
  LOAD_ACCOUNT_FAILURE_ACTION,
  LOAD_ACCOUNTS_FAILURE_ACTION
} from "../ducks/data";

const _ = require("lodash");

let UserFriendlyErrors = {};
UserFriendlyErrors[LOAD_CONDITIONS_FAILURE_ACTION.getType()] =
  "Issue loading conditions";
UserFriendlyErrors[DELETE_CONDITION_FAILURE_ACTION.getType()] =
  "Archiving condition failed";
UserFriendlyErrors[DELETE_PATIENT_CONDITION_FAILURE_ACTION.getType()] =
  "Archiving condition failed";
UserFriendlyErrors[DELETE_PATIENT_PROGRAM_FAILURE_ACTION.getType()] =
  "Archiving Patient Flow failed";
UserFriendlyErrors[DELETE_PROGRAM_FAILURE_ACTION.getType()] =
  "Archiving Flow failed";
UserFriendlyErrors[DELETE_PROGRAM_ITEM_FAILURE_ACTION.getType()] =
  "Archiving Flow Item failed";
UserFriendlyErrors[DELETE_TASK_FAILURE_ACTION.getType()] =
  "Archiving Item failed";
UserFriendlyErrors[LINK_PROGRAMS_FAILURE_ACTION.getType()] =
  "Attaching Flow failed";
UserFriendlyErrors[LOAD_PATIENT_FAILURE_ACTION.getType()] =
  "Retrieving patient failed";
UserFriendlyErrors[LOAD_PATIENTS_FAILURE_ACTION.getType()] =
  "Retrieving patients failed";
UserFriendlyErrors[LOAD_PROGRAM_FAILURE_ACTION.getType()] =
  "Retrieving Flow failed";
UserFriendlyErrors[LOAD_PROGRAMS_FAILURE_ACTION.getType()] =
  "Retrieving Flows failed";
UserFriendlyErrors[LOAD_TASKS_FAILURE_ACTION.getType()] =
  "Retrieving Items failed";
UserFriendlyErrors[SAVE_CONDITION_FAILURE_ACTION.getType()] =
  "Saving condition failed";
UserFriendlyErrors[SAVE_PATIENT_CONDITION_FAILURE_ACTION.getType()] =
  "Saving condition failed";
UserFriendlyErrors[SAVE_PATIENT_FAILURE_ACTION.getType()] =
  "Saving patient failed";
UserFriendlyErrors[SAVE_PATIENT_PROGRAM_FAILURE_ACTION.getType()] =
  "Saving Flow failed";
UserFriendlyErrors[SAVE_PATIENT_PROGRAM_ITEM_FAILURE_ACTION.getType()] =
  "Saving patient flow failed";
UserFriendlyErrors[SAVE_PROGRAM_FAILURE_ACTION.getType()] =
  "Saving Flow failed";
UserFriendlyErrors[SAVE_PROGRAM_ITEM_FAILURE_ACTION.getType()] =
  "Saving Flow Item failed";
UserFriendlyErrors[SAVE_TASK_FAILURE_ACTION.getType()] = "Saving task failed";
UserFriendlyErrors[DELETE_ACCOUNT_FAILURE_ACTION.getType()] =
  "Archiving account failed";
UserFriendlyErrors[DELETE_LOCATION_FAILURE_ACTION.getType()] =
  "Archiving location failed";
UserFriendlyErrors[DELETE_USER_FAILURE_ACTION.getType()] =
  "Archiving user failed";
UserFriendlyErrors[SAVE_ACCOUNT_FAILURE_ACTION.getType()] =
  "Saving account failed";
UserFriendlyErrors[SAVE_LOCATION_FAILURE_ACTION.getType()] =
  "Saving location failed";
UserFriendlyErrors[SAVE_USER_FAILURE_ACTION.getType()] = "Saving user failed";
UserFriendlyErrors[LOAD_ACCOUNT_FAILURE_ACTION.getType()] =
  "Loading account failed";

UserFriendlyErrors[LOAD_ACCOUNTS_FAILURE_ACTION.getType()] =
  "Loading account failed";
export const handleErrorEpic = (action$, state$) =>
  action$.pipe(
    ofType(
      SAVE_PROGRAM_ITEM_FAILURE_ACTION.getType(),
      LOAD_CONDITIONS_FAILURE_ACTION.getType(),
      DELETE_CONDITION_FAILURE_ACTION.getType(),
      DELETE_PATIENT_CONDITION_FAILURE_ACTION.getType(),
      DELETE_PATIENT_PROGRAM_FAILURE_ACTION.getType(),
      DELETE_PROGRAM_FAILURE_ACTION.getType(),
      DELETE_PROGRAM_ITEM_FAILURE_ACTION.getType(),
      DELETE_TASK_FAILURE_ACTION.getType(),
      LINK_PROGRAMS_FAILURE_ACTION.getType(),
      LOAD_PATIENT_FAILURE_ACTION.getType(),
      LOAD_PATIENTS_FAILURE_ACTION.getType(),
      LOAD_PROGRAM_FAILURE_ACTION.getType(),
      LOAD_PROGRAMS_FAILURE_ACTION.getType(),
      LOAD_TASKS_FAILURE_ACTION.getType(),
      SAVE_CONDITION_FAILURE_ACTION.getType(),
      SAVE_PATIENT_CONDITION_FAILURE_ACTION.getType(),
      SAVE_PATIENT_FAILURE_ACTION.getType(),
      SAVE_PATIENT_PROGRAM_FAILURE_ACTION.getType(),
      SAVE_PATIENT_PROGRAM_ITEM_FAILURE_ACTION.getType(),
      SAVE_PROGRAM_FAILURE_ACTION.getType(),
      SAVE_PROGRAM_ITEM_FAILURE_ACTION.getType(),
      SAVE_TASK_FAILURE_ACTION.getType(),
      DELETE_ACCOUNT_FAILURE_ACTION.getType(),
      DELETE_LOCATION_FAILURE_ACTION.getType(),
      DELETE_USER_FAILURE_ACTION.getType(),
      SAVE_ACCOUNT_FAILURE_ACTION.getType(),
      SAVE_LOCATION_FAILURE_ACTION.getType(),
      SAVE_USER_FAILURE_ACTION.getType(),
      LOAD_ACCOUNT_FAILURE_ACTION.getType(),
      LOAD_ACCOUNTS_FAILURE_ACTION.getType()
    ),
    mergeMap(action => {
      if (action.payload) {
        if (action.payload.status === 401) {
          return of(push("/login"));
        } else if (
          _.isEmpty(action.payload.attributes) &&
          action.payload.title
        ) {
          notification.open({
            type: "error",
            message: UserFriendlyErrors[action.type],
            description: `${action.payload.title} - ${action.payload.detail}`,
            duration: 0
          });
          return empty();
        } else {
          return empty();
        }
      } else {
        return empty();
      }
    })
  );



// WEBPACK FOOTER //
// ./src/epics/error.js